import {MarketingParams} from "../../../common/interfaces/marketing-params.interface";
import {IOpenMyAccountOptions} from "./handlers/my-account/my-account.external-link-handler.interface";

export type ExternalLinkViewMode = 'window' | 'iframe' | 'redirect' | 'second_web_view';

export interface OpenLinkParams {
  source?: string;
  sourceLink?: string;
  options?: any;
  view?: ExternalLinkViewMode;
  resolveByCallback?: boolean;
  addCloseOption?: boolean;
  priorityLevel?: string;
}

export interface OpenContactUsOptions{
  view: ExternalLinkViewMode;
}

export enum OpenMembershipResponse {
  unknown = 0,
  play = 1,
  deposit = 2,
  close = 3
}


export interface OpenRichPageOptions {
  campaignId: string;
}


export interface IExternalLinksService {
  openExternalBrand(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL?: boolean): Promise<void>;
  openLink(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL?: boolean): Promise<any>;
  openMyAccount(options?: IOpenMyAccountOptions): Promise<any>;
  openMembership(marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<OpenMembershipResponse>;
  openUploadDocument(marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<any>;
  openContactUs(options?: OpenContactUsOptions, marketingParams?: MarketingParams, resolveByCallback?: boolean): Promise<any>;
  openHelpPage(): Promise<any>;
  openDownloadApp(): Promise<any>;
  openResponsibleGamblingLink(view?:number):void;
  openOldChat(): Promise<void>;
  openPendingPlayApplication(token: string): Promise<void>;
  openSafeToPlay(): Promise<void>;
  openRichPage(options: OpenRichPageOptions): Promise<void>;
  openSport(): Promise<void>;
  openInternalUrl(url: string): Promise<void>;
  openExternalUrl(url: string): Promise<void>;
}
